<template>
    <span v-if="mostrarBtn">
        <span class="text-primary ml-1">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Evento"
                @click.stop="selecionarEvento()"
            ></i>
        </span>
        <b-modal
            id="modalEvento"
            v-model="mostrarModal"
            @show="pesquisarEventoAtual()"
        >
            <div slot="modal-title">Entrega - Atualizar Evento</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row class="mb-3">
                <b-col sm="12">
                    <b-form-checkbox
                        v-model="eventoEspecial"
                        :value="true"
                        :unchecked-value="false"
                    >
                        Evento Especial
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" v-if="!eventoEspecial">
                    <b-form-group>
                        <label class="required">Código do novo Evento</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                v-model="codEvento"
                                :state="$v.codEvento.$error ? false : null"
                                @input="$v.codEvento.$touch()"
                                v-mask="'####################'"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                    variant="primary"
                                    @click="pesquisarEvento()"
                                    title="Clique para pesquisar o Evento"
                                >
                                    <i class="fa fa-search"></i>
                                </b-button>
                            </b-input-group-append>
                            <b-form-invalid-feedback
                                >O código do evento é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="eventoEspecial">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="entrega.eventoEspecial">
                <b-col sm="12">
                    <div>
                        <h5 class="heading-1">
                            <span>DADOS DO EVENTO ATUAL - ESPECIAL</span>
                        </h5>
                        <b-form-group>
                            <label>Justificativa</label>
                            <b-form-textarea
                                :disabled="true"
                                :rows="4"
                                v-model="entrega.justificativaEvento"
                            ></b-form-textarea>
                        </b-form-group>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="!entrega.eventoEspecial">
                <b-col sm="12">
                    <div>
                        <h5 class="heading-1">
                            <span>DADOS DO EVENTO ATUAL NO SAS</span>
                        </h5>
                        <evento :evento="eventoAtual"></evento>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="!eventoEspecial">
                <b-col sm="12">
                    <div v-if="evento" class="mt-2">
                        <h5 class="heading-1">
                            <span>DADOS DO EVENTO NOVO NO SAS</span>
                        </h5>
                        <evento :evento="evento"></evento>
                    </div>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharEvento()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarSalvar"
                    @click.stop="confirmarEvento()"
                    class="ml-2"
                >
                    <span> <i class="fa fa-edit"></i> Atualizar Evento </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import Evento from './Evento'
import { entregaStatus } from './EntregaStatus'

export default {
    components: {
        Evento
    },

    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        entregasServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            codEvento: '',
            erros: [],
            mostrarModal: false,
            evento: null,
            eventoAtual: null,
            justificativa: null,
            eventoEspecial: false
        }
    },

    methods: {
        selecionarEvento() {
            this.mostrarModal = true
        },

        fecharEvento() {
            this.mostrarModal = false
            this.codEvento = ''
            this.evento = null
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        confirmarEvento() {
            this.$swal({
                title: 'Atualizar Evento',
                html: `Confirma a atualização do evento ${
                    this.eventoEspecial ? 'especial' : this.codEvento
                } na entrega?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.atualizarEvento()
                }
            })
        },

        atualizarEvento() {
            this.$store.dispatch('addRequest')
            let entregaEventoDto = {
                entregaId: this.$route.params.entregaId,
                eventoId: !this.eventoEspecial ? this.codEvento : 0,
                justificativa: this.eventoEspecial ? this.justificativa : null
            }
            this.entregasServicos
                .atualizarEvento(entregaEventoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                            this.fecharEvento()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        pesquisarEvento() {
            this.$store.dispatch('addRequest')
            this.entregasServicos
                .pesquisarEvento(this.$route.params.entregaId, this.codEvento)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.evento = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao pesquisar evento!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        pesquisarEventoAtual() {
            if (this.entrega.eventoEspecial) {
                this.justificativa = this.entrega.justificativaEvento
                this.eventoEspecial = true
            } else {
                this.$store.dispatch('addRequest')
                this.entregasServicos
                    .pesquisarEvento(
                        this.$route.params.entregaId,
                        this.entrega.codEvento
                    )
                    .then(response => {
                        if (response) {
                            if (response.success) {
                                this.eventoAtual = response.data
                            } else {
                                this.$toast.error(
                                    'Erro ao pesquisar evento!!!',
                                    'ERROR',
                                    this.$toastConfig.error
                                )
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    })
            }
        }
    },

    computed: {
        mostrarBtn() {
            let retorno =
                this.$temAcesso('CRED-GEST-ENTR-02') &&
                (this.entrega.status === entregaStatus.APROVADA ||
                    this.entrega.status === entregaStatus.PENDENCIA_SAS) &&
                (this.entrega.codEvento || this.entrega.eventoEspecial)
            return retorno
        },

        desabilitarSalvar() {
            if (this.eventoEspecial) {
                return (
                    this.justificativa == this.entrega.justificativaEvento ||
                    this.$v.justificativa.$error
                )
            } else {
                return (
                    this.evento == null ||
                    this.evento.eventoId != this.codEvento ||
                    (this.eventoAtual &&
                        this.evento.eventoId == this.eventoAtual.eventoId)
                )
            }
        }
    },

    validations: {
        codEvento: {
            required
        },
        justificativa: {
            required
        }
    }
}
</script>
